import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { useEffect, useState, useMemo } from "react";
import correctIcons from "../../../Assets/AppComponent/icons/Group 359.svg";
import Pendingimg from "../../../Assets/AppComponent/icons/Group 145.svg";
import {
  getSideBarfilesActions,
  setAppraisalAction,
  setTheoptions,
  setThecountBasedRenders,
  setTheAppraisalRange2,
  setTheAppraisalRange1,
  settheAppraisalEmployeeDesignation,
  setTheAppraisalEmploeeeStatuState,
} from "../../../Redux/Slice";
import { NavLink } from "react-router-dom";
import ReactTable from "../../AppComponent/Table";
import AppraisalEdit from "./AppraisalEdit";
import Select from "react-select";
import { DateRangePicker, Stack } from "rsuite";
import subDays from "date-fns/subDays";
import startOfWeek from "date-fns/startOfWeek";
import endOfWeek from "date-fns/endOfWeek";
import addDays from "date-fns/addDays";
import "rsuite/dist/rsuite.css";
import isAfter from "date-fns/isAfter";

import { differenceInDays } from "date-fns";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

import _, { values } from "lodash";
import EditImages from "../../../Assets/AppComponent/Overall_icons/UDS Needs Image-04 (1).svg";
import ThumbsImage from "../../../Assets/AppComponent/Overall_icons/UDS Needs Image-13.svg";


const Appraisal = () => {
  const dispatch = useDispatch();
  const state = useSelector((state) => state);
  const [dtpageindex, setdtPageindex] = useState(1);
  const [dtpagesize, setdtPagesize] = useState(20);
  const [pageSize, setPageSize] = useState(20);
  const [newpages, setNewpage] = useState(1);
  const [currentPage, setCurrentPage] = useState(1);
  const [EmployeePop, setEmployeePop] = useState(false);
  const [EmployeeIDs, setEmployeeIDs] = useState();
  const [DeleteID, setDeleteId] = useState();
  const [DeletePopup, setDeletePopup] = useState(false);
  const [search, setsearch] = useState("");
  const stateDisplay = useSelector(
    (state) => state.SideBarActive.SidebarActive
  );
  const [sno, setsno] = useState(0);

  ///---filter for white collar--------
  const [EmpRoles, setEmplyeRole] = useState([
    {
      value: "",
      label: "ALL",
    },
    {
      value: "1",
      label: "UDS",
    },
    {
      value: "2",
      label: "CLIENT",
    },
  ]);

  const [filterForWhite, setFilters] = useState({ white_collar: 

    state.StateManagementOverallCall.Appraisaldesignation?.value == ""?
    "":
    state.StateManagementOverallCall.Appraisaldesignation?.value == 1 ?
    true:
    false



   });
  const HandleEMprole = (e) => {
    setdtPageindex(1);

    if (e != null) {
       dispatch(settheAppraisalEmployeeDesignation(e))
      if (e.value == 1) {
        setFilters({
          ...filterForWhite,
          white_collar: true,
        });
      } else if (e.value == 2) {
        setFilters({
          ...filterForWhite,
          white_collar: false,
        });
      } else if (e.value == "") {
        setFilters({
          ...filterForWhite,
          white_collar: "",
        });
         dispatch(settheAppraisalEmployeeDesignation({value:"",label:"ALL"}))
      }
    }
  };

  var today = new Date();
  var priorDate = new Date(new Date().setDate(today.getDate() - 30));
  var it = convert(state.StateManagementOverallCall.AppraisalRange1);
  var gt = convert(state.StateManagementOverallCall.AppraisalRange2);
  const [range, setrange] = useState(
    state.StateManagementOverallCall.AppraisalRange1 == ""
      ? // [it, gt]
        []
      : [it, gt]
  );

  function convert(str) {
    var date = new Date(str),
      mnth = ("0" + (date.getMonth() + 1)).slice(-2),
      day = ("0" + date.getDate()).slice(-2);
    return [date.getFullYear(), mnth, day].join("-");
  }

  //----Handle----Date=-----Changes---
  const handlechangedate = (value) => {
    if (value != null) {
      setrange((oldArray) => [...oldArray, value.slice(0, 10)]);
    }
  };

  useEffect(() => {
    if (range.length > 0 && !range.includes("NaN-aN-aN")) {
      dispatch(setTheAppraisalRange1(range[0]));
      dispatch(setTheAppraisalRange2(range[1]));
    }
  }, [range]);

  const FileterState = {
    status: state.StateManagementOverallCall.AppraisalStatusState?.value,
  };
  const [selectDisplay, setDisplay] = useState([]);
  const [selectVal, SetSelectval] = useState(FileterState);
  const [FState, SetStates] = useState(false);
  const [place, SetPlace] = useState("");

  ////--_FIlter--------------------------
  const [Filter, SetFilter] = useState(true);
  /// console.log(state.NumberCounts, "fsdf");
  const options = [
    { value: "", label: "All" },
    { value: "pending", label: "Pending" },
    { value: "decline", label: "Decline" },
    { value: "approved", label: "Approved" },
  ];


  useEffect(() => {
    if (range.length > 0 && !range.includes("NaN-aN-aN")) {
      const payload = {
        search: search,
        page_size: 10,
        page: dtpageindex,
        selectVal: selectVal,
        white_collar: filterForWhite.white_collar,
        from_date: range[0],

        to_date: range[1],
      };
      dispatch(setAppraisalAction(payload));
    }
  }, [selectVal, filterForWhite, range, dtpageindex , search]);

  const [sel, setSelected] = useState();

  const ClearState = (Counts) => {
    if (Counts == 2) {
      SetSelectval({
        ...selectVal,
        status: "",
      });
      setdtPageindex(1);
      dispatch(setTheAppraisalEmploeeeStatuState({value:"",label:"All"}));

    }
  };
  //--------_____Filter-----------Based---On----Status--
  const count = (Counts, values, sel, SelectedValues) => {
    // console.log(Counts, values, sel, "Logs");
    //console.log(SelectedValues, "selectedvaluess");
    setdtPageindex(1);
    setDisplay(SelectedValues);
    setSelected(sel);
    SetStates(true);
    dispatch(setTheAppraisalEmploeeeStatuState(SelectedValues));
    if (values == "Completed") {
      SetSelectval({
        ///Completed
        ...selectVal,
        status: "completed",
      });
    } else if (values == "Pending") {
      ///Pending
      SetSelectval({
        ...selectVal,
        status: "pending",
      });
    } else if (values == "Decline") {
      //Decline
      SetSelectval({
        ...selectVal,
        is_decline: true,
        is_pending: "",
        approved: "",
        status: "decline",
      });
    } else if (values == "Approved") {
      //Approve
      SetSelectval({
        ...selectVal,
        status: "approved",
      });
    } else if (values == "ALL") {
      //Approve
      SetSelectval({
        ...selectVal,
        status: "",
      });
    }
  };
  const pagesize = (arg) => {
    setdtPagesize(arg);
  };
  const pageindex = (arg) => {
    //  console.log(arg, "args");
    setdtPageindex(arg);
  };

  const handlePageChange = (newPage) => {
    if (newPage < state.AppraisliceCall.Total_Count) {
      setCurrentPage(newpages + 1);

      setNewpage(newPage + 1);
      const pageEntries = {
        search: search,
        page_size: 10,
        page: newPage,
        selectVal: selectVal,
        white_collar: filterForWhite.white_collar,
        from_date: range[0],

        to_date: range[1],
      };
      dispatch(setAppraisalAction(pageEntries));
    }
  };
  const handleNext = (next) => {
    
        setdtPageindex(next + 1);
    
  };

   const GotoEnteredPage =(gotopage)=>{
     setdtPageindex(gotopage)
   }

   const handlePrevious = (previous) => {
    if (previous != 0) {
      setdtPageindex(previous);
   
    }
  };
  function tochange(e) {
    setdtPageindex(1);
    debouncedSearch(e);

  }
  const debouncedSearch = useMemo(
    () =>
      _.debounce((e) => {
        setsearch(e);
      }, 500),
    []
  );
  React.useEffect(() => {
    return () => {
      debouncedSearch.cancel();
    };
  }, [debouncedSearch]);

  const capitalizeFirstLetter = (Letter) => {
    return Letter.charAt(0).toUpperCase() + Letter.slice(1);
  };

  const columns = useMemo(
    () => [
      {
        Header: "Tnx Id",
        accessor: "",
        Cell: (row) => {
          if (
            row.row.original.user_id.id != undefined &&
            row.row.original.user_id.id != null
          ) {
            const userId = row.row.original.user_id.id;
            const lastFourDigits = userId.slice(-6);
            // console.log(userId, "98q37982739row");
            // console.log(sno);
            return <p>{lastFourDigits}</p>;
          }
        },
      },

      {
        Header: filterForWhite.white_collar ? "User Name" : "Employee Name",
        accessor: "",
        Cell: (row) => {
          return (
            <>
              {row.row.original.user_id.first_name ? (
                <span>{row.row.original.user_id.first_name}</span>
              ) : (
                <span>---</span>
              )}
            </>
          );
        },
      },
      {
        Header: "Created date",
        accessor: "",
        Cell: (row) => {
          const dateString = row.row.original.created_at;
          const dateObject = new Date(dateString);
          const hours = dateObject.getHours();
          const minutes = dateObject.getMinutes();
          const seconds = dateObject.getSeconds();
          const amOrPm = hours >= 12 ? "PM" : "AM";
          const twelveHourFormat = hours % 12 || 12;

          const formattedMinutes = minutes < 10 ? `0${minutes}` : minutes;

          const formattedTime = `${twelveHourFormat}:${formattedMinutes} ${amOrPm}`;

          return (
            <>
              <p
              >
                {`${
                  row.row.original.created_at.slice(0, 10) +
                  "  " +
                  formattedTime
                }`}
              </p>
            </>
          );
        },
      },
      {
        Header: " Purpose",
        accessor: "",
        Cell: (row) => {
          return (
            <>
              {row.row.original.purpose ? (
                <span>{row.row.original.purpose}</span>
              ) : (
                <span>---</span>
              )}
            </>
          );
        },
      },
      {
        Header: "Branch",
        accessor: "",
        Cell: (row) => {
          return (
            <>
              {row.row.original.client_id != undefined &&
              row.row.original.client_id.client_name != undefined ? (
                <span>{row.row.original.client_id.client_name}</span>
              ) : (
                <span>---</span>
              )}
            </>
          );
        },
      },

      {
        Header: "Status",
        accessor: "status",
        Cell: (row) => {
          const originalString = row.row.original.status;
          const capitalizedString = capitalizeFirstLetter(originalString);
          return (
            <>
              {row.row.original.status != undefined ? (
                <>
                  {row.row.original.status.toLowerCase() == "pending" ? (
                    <div className="StatusList">
                      <img src={Pendingimg} />
                      <span>{capitalizedString}</span>
                    </div>
                  ) : (
                    <>
                      {row.row.original.status.toLowerCase() == "decline" ? (
                        <div className="StatusList">
                          <div className="DeclineStatus">
                            <span>x</span>
                          </div>
                          <span>{capitalizedString}</span>
                        </div>
                      ) : (
                        <>
                          {row.row.original.status.toLowerCase() ==
                          "approved" ? (
                            <div className="StatusList">
                              <img src={correctIcons} />
                              <span>{capitalizedString}</span>
                            </div>
                          ) : null}
                        </>
                      )}
                    </>
                  )}
                </>
              ) : (
                <span>---</span>
              )}
            </>
          );
        },
      },

      {
        Header: "Action",
        accessor: "",
        Cell: (row) => {
          return (
            <>
              <div
                class="actions"
                style={{
                  display: "flex",
                  justifyContent: "flex-start",
                  gap: "5px",
                }}
              >
                {/* {row.row.original.status.toLowerCase() == "pending" ? ( */}

                {row.row.original.status.toLowerCase() === "approved" ? (
                  <button
                    className=" btn Status"
                    component="span"
                    style={{ cursor: "not-allowed" }}
                  >
                    <span className="OuterActionSpan">
                      {" "}
                      <span  className="EditImages">
                    <img src={ThumbsImage}/>
                  </span>
                      <span className="ActionsList"> Approved </span>
                    </span>
                  </button>
                ) : (
                  <>
                    {row.row.original.status.toLowerCase() === "decline" ? (
                      <button
                        className=" btn Status"
                        component="span"
                        style={{ cursor: "not-allowed" }}
                        onClick={(e) => {
                          if (
                            !row.row.original.status.toLowerCase() == "approved"
                          ) {
                            setEmployeePop(true);
                            setEmployeeIDs(row.row.original.id);
                          }
                        }}
                      >
                        <span className="OuterActionSpan">
                        <span  className="EditImages">
                    <img src={ThumbsImage}/>
                  </span>
                          <span className="ActionsList"> Decline </span>
                        </span>
                      </button>
                    ) : (
                      <>
                        {row.row.original.status.toLowerCase() === "pending" ? (
                          <button
                            className=" btn Status"
                            component="span"
                            onClick={(e) => {
                              setEmployeePop(true);
                              setEmployeeIDs(row.row.original.id);
                            }}
                          >
                            <span className="OuterActionSpan">
                            <span  className="EditImages">
                    <img src={EditImages}/>
                  </span>
                              <span className="ActionsList"> Approve </span>
                            </span>
                          </button>
                        ) : null}
                      </>
                    )}
                  </>
                )}
              </div>
            </>
          );
        },
      },
    ],
    [sno]
  );
  const cleaningrange = () => {
    //setrange([gt,it]);
  };

  const predefinedBottomRanges = [
    {
      label: "Today",
      value: [new Date(), new Date()],
      placement: "left",
    },
    {
      label: "Yesterday",
      value: [addDays(new Date(), -1), addDays(new Date(), -1)],
      placement: "left",
    },
    {
      label: "This week",
      value: [startOfWeek(new Date()), endOfWeek(new Date())],
      placement: "left",
    },
    {
      label: "Last week",
      value: (value, index) => {
        const [start = new Date()] = value[index] || [];
        return [
          addDays(startOfWeek(start, { weekStartsOn: 0 }), -7),
          addDays(endOfWeek(start, { weekStartsOn: 0 }), -7),
        ];
      },
      placement: "left",
    },
    {
      label: "Last 30 days",
      value: [subDays(new Date(), 29), new Date()],
      placement: "left",
    },
  ];
  const openMe = ()=>{
    const rsAnimFade = document.querySelector('.rs-anim-fade');
    if (rsAnimFade) {
      rsAnimFade.style.setProperty('left', '1076.8px', 'important');
      rsAnimFade.style.setProperty('top', '187.109px', 'important');   
    }
   }
  
   const CloseDateRange = ()=>{
    const rsAnimFade = document.querySelector('.rs-anim-fade');
    if (rsAnimFade) {
      rsAnimFade.style.setProperty('display', 'none', 'important');
      // rsAnimFade.style.setProperty('top', '184.109px', 'important');   
    }
   }

  return (
    <>
      <div className={stateDisplay ? "outterContent" : "inner-Content"}>
        <div
          className="Header-Details ClientBranch row"
          style={{ padding: "14px 28px" }}
        >
          <div
            class="col-sm-7 auto"
            style={{
              display: "flex",
              flexDirection: "column",
              alignItems: "flex-start",
              justifyContent: "flex-start",
            }}
          >
            <h3>Appraisal</h3>
          </div>
        </div>

        <div
          className="row Filters"
          style={{
            padding: "15px 28px",
            margin: "0px",
            position: "relative",
            zIndex: "30",
               
            marginLeft: "0px",
            marginRight: "0px",
            // top: "-30px",
          }}
        >
          <div className="col-6"></div>

          <div className="col-sm-3"></div>

          <div
            className="col-sm-3"
            style={{
              zIndex: "20",
              marginLeft: "0px",
              display: "flex",

              flexDirection: "column",
              marginTop: "-31px",
            }}
          >
            <label
              for="validationCustom01"
              class="form-label"
              style={{ marginBottom: "11px" }}
            >
              {/* State Name */}
              Select Date
              <span style={{ color: "red" }}>*</span>
            </label>

            <div className="datepicker_dash" style={{ marginTop: "-5px" }}>
              <DateRangePicker
                defaultValue={
                  state.StateManagementOverallCall.AppraisalRange1 == ""
                    ? []
                    : [
                        new Date(
                          state.StateManagementOverallCall.AppraisalRange1
                        ),
                        new Date(
                          state.StateManagementOverallCall.AppraisalRange2
                        ),
                      ]
                }
                disabledDate={(date) => isAfter(date, new Date())}
                editable={false}
                appearance="default"
                placement="bottomEnd"
                size="lg"
                ranges={predefinedBottomRanges}
                placeholder="From - To"
                style={{
                  width: "290px",

                  padding: 10,
                }}
                onOpen={() => {
                  openMe()
                }}
             onClose={() => {
                CloseDateRange()
                   }}

                onClean={(e) => cleaningrange(e)}
                onChange={(e) => {
                  if (e != null && e.length === 2) {
                    const [startDate, endDate] = e;
                    const diffDays = differenceInDays(endDate, startDate);
                    // if (diffDays === 30) {
                    //   // Since we are using inclusive range, difference should be 30 for 31 days
                    //   setrange([]);
                    //   e.forEach((newValue) => {
                    //     const tzoffset = new Date().getTimezoneOffset() * 60000; // offset in milliseconds
                    //     const localISOTime = new Date(newValue - tzoffset)
                    //       .toISOString()
                    //       .slice(0, -1);
                    //     handlechangedate(localISOTime);
                    //   });
                    // } else if (diffDays < 30) {
                    //   setrange([]);
                    //   e.forEach((newValue) => {
                    //     const tzoffset = new Date().getTimezoneOffset() * 60000; // offset in milliseconds
                    //     const localISOTime = new Date(newValue - tzoffset)
                    //       .toISOString()
                    //       .slice(0, -1);
                    //     handlechangedate(localISOTime);
                    //   });
                    // } else {
                    //   toast.error("Please select a range of exactly 31 days.", {
                    //     position: toast.POSITION.TOP_RIGHT,
                    //   });
                    // }


                    setrange([]);
                    e.forEach((newValue) => {
                      const tzoffset = new Date().getTimezoneOffset() * 60000; // offset in milliseconds
                      const localISOTime = new Date(newValue - tzoffset)
                        .toISOString()
                        .slice(0, -1);
                      handlechangedate(localISOTime);
                    });
                    
                  }
                }}
              />
            </div>
          </div>

          {/* </div> */}
        </div>

        <div style={{ padding: " 0px 40px", marginTop: "-13px" }}>
          {/* <div
            style={{
              display: "flex",
              justifyContent: "flex-end",
              position: "relative",
              top: "85px",
              zIndex: "99",
              justifyContent: "space-around",
              alignItems: "center",
            }}
          >
            <div></div>
            <div
              class="col-sm-2 field-div"
              style={{
                position: "relative",
                top: "-11px",
                display: "flex",
                justifyContent: "flex-end",
                flexDirection: "column",
              }}
            >
              <label
                for="validationCustom02"
                class="form-label"
                style={{ fontSize: "15px" }}
              >
                Employee Role
              </label>

              <Select
                className="Selects"
                styles={{ position: "relative", top: "60px" }}
                onChange={(e) => {
                  HandleEMprole(e);
                }}
                value={EMpROleSelected}
                options={EmpRoles}
                placeholder="search"
              />
            </div>
          </div> */}

          <ReactTable
            data={state.AppraisliceCall.AppraaisalData}
            columns={columns}
            totalItems={state.AppraisliceCall.Total_Count}
            currentPage={currentPage}
            onChange={tochange}
            setCurrentPage={setCurrentPage}
            pagesize={pagesize}
            onPrevious={handlePrevious}
            onNextpage={handleNext}
            GotoEnteredPage={GotoEnteredPage}
            dtpagesize={pageSize}
            dtpageindex={dtpageindex}
            pageindex={pageindex}
            datacount={state.AppraisliceCall.Total_Count}
            onPageChange={handlePageChange}
            values={state.StateManagementOverallCall.AppraisalStatusState}
            options={options}
            Filter={Filter}
            count={count}
            ClearState={ClearState}
            placeHold={place}
            ///--- emoloyee role based filters -
            EmployeeRoleTrue={true}
            EmployeeRoleOption={EmpRoles}
            EMpROleSelected={state.StateManagementOverallCall.Appraisaldesignation}
            HandleEMprole={HandleEMprole}
            setsno={setsno}
            sno={sno}
            id={"spe"}
            ApproveRequestFilter={true}

          />
        </div>
      </div>

      {EmployeePop && EmployeeIDs != undefined ? (
        <AppraisalEdit
          show={EmployeeIDs}
          setShow={setEmployeePop}
          from_date={range[0]}
          to_date={range[1]}
          currentPage={dtpageindex}
          EditId={EmployeeIDs}
          white_collar={filterForWhite.white_collar}
          search={search}
        />
      ) : null}
    </>
  );
};

export default Appraisal;
